import { Link } from "react-router-dom";
import type { HotEvent } from "@/mocks/events";
import { TrendBadge } from "@/components/base/Shared";
import { formatHeat } from "@/utils/format";

export default function EventCard({ event }: { event: HotEvent }) {
  return (
    <article className="group h-full flex flex-col rounded-2xl bg-background-50 border border-background-200 hover:border-primary-300 overflow-hidden transition-colors">
      <Link to={`/event/${event.id}`} className="block">
        <div className="relative w-full h-40 md:h-44 overflow-hidden">
          <img
            src={event.cover}
            alt={`${event.title}热度走势与传播路径示意图`}
            title={`${event.title} · 网红黑曝发酵追踪`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 text-xs font-label text-foreground-900">
            {event.category}
          </span>
          <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-secondary-900/85 text-[11px] font-label text-background-50">
            {event.plat}首爆
          </span>
        </div>
      </Link>

      <div className="flex flex-col flex-1 p-5">
        <Link to={`/event/${event.id}`}>
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
            {event.title}
          </h3>
        </Link>
        <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
          {event.summary}
        </p>

        <div className="mt-4 flex flex-wrap items-center gap-2">
          {event.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-50 text-secondary-800 text-xs whitespace-nowrap"
            >
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="font-label text-sm text-primary-600">{formatHeat(event.heat)}</span>
            <TrendBadge trend={event.trend} rate={event.trendRate} />
          </div>
          <span className="text-xs text-foreground-500">
            话题 {event.topicCount}万
          </span>
        </div>
      </div>
    </article>
  );
}